import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { SelectModule } from 'primeng/select';
import { Popover, PopoverModule } from 'primeng/popover';
import { filter, tap } from 'rxjs';
import { MenuCollapseItemComponent } from '../../../menu-collapse-item/menu-collapse-item.component';
import { NavigationItem } from '../../../../interfaces/navigationList.interface';
import { PageContainerService } from '../../../../services/page-container.service';

@Component({
  selector: 'st-top-header-single-tab',
  standalone: true,
  imports: [
    CommonModule,
    SelectModule,
    FormsModule,
    PopoverModule,
    MenuCollapseItemComponent,
  ],
  templateUrl: './top-header-single-tab.component.html',
  styleUrls: ['./top-header-single-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopHeaderSingleTabComponent {
  @ViewChild('op') overlayPanel!: Popover;
  navigationItem = input.required<NavigationItem>();

  activeChild!: NavigationItem;

  navigationItem$ = this.pageContainerService.activeSectionRoute.pipe(
    tap(nav => {
      if (nav?.children?.length) {
        this.setActiveItem(nav);
      }
    }),
  );

  routerEvent$ = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    tap(event => {
      this.overlayPanel.hide();
    }),
  );

  constructor(
    readonly pageContainerService: PageContainerService,
    readonly router: Router,
  ) {}

  setActiveItem(nav: NavigationItem | null) {
    if (!nav) {
      return;
    }
    let currentPath = this.pageContainerService
      .getRoutePath()
      .find(x => x.url === this.router.url)?.routePath;

    const index = nav.children.findIndex(
      y => y && currentPath && y.id === currentPath[1],
    );
    if (index !== -1) {
      this.activeChild = nav.children[index];
    } else {
      return;
    }
  }
}
